// ============================================================
// FILE: resources/js/config/echo.js
// USPATIH GO — Laravel Echo & Pusher WebSocket Configuration
// ============================================================

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const PLACEHOLDER_KEYS = new Set([
  '',
  'your_app_key',
  'your-app-key',
  'null',
  'undefined',
]);

function isValidPusherKey(key) {
  if (!key || typeof key !== 'string') return false;
  const normalized = key.trim().toLowerCase();
  if (PLACEHOLDER_KEYS.has(normalized)) return false;
  if (normalized.startsWith('your_') || normalized.includes('your_app')) return false;
  return normalized.length >= 8;
}

const pusherKey = window.PUSHER_APP_KEY || import.meta.env.VITE_PUSHER_APP_KEY;
const broadcastingEnabled = import.meta.env.VITE_BROADCAST_ENABLED !== 'false';

if (broadcastingEnabled && isValidPusherKey(pusherKey)) {
  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: pusherKey,
    cluster: window.PUSHER_APP_CLUSTER || import.meta.env.VITE_PUSHER_APP_CLUSTER || 'ap1',
    wsHost: window.PUSHER_HOST || import.meta.env.VITE_PUSHER_HOST || window.location.hostname,
    wsPort: window.PUSHER_PORT || import.meta.env.VITE_PUSHER_PORT || 6001,
    wssPort: window.PUSHER_PORT || import.meta.env.VITE_PUSHER_PORT || 6001,
    forceTLS: (window.PUSHER_SCHEME || import.meta.env.VITE_PUSHER_SCHEME || 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    authEndpoint: '/broadcasting/auth',
    auth: {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('uspatih_token') || ''}`,
      },
    },
  });
} else {
  window.Echo = null;
}

export default window.Echo;
